import routes from "@/pages/_routes.json";
import { useRouter } from "next/router";

type Routes = {
  aboutUs: string;
  contact: string;
  team: string;
  programs: string;
  programDetail: string;
  articles: string;
  articleDetail: string;
  announcements: string;
  announcementDetail: string;
};

export default function useBrowserRoutes() {
  const { locale } = useRouter();

  return routes[locale] as Routes;
}
